import { CalendarDays, Newspaper, Swords, ScrollText, Heart, ShoppingBag, Compass, Image, BookOpen } from 'lucide-react';
import { FortIcon, PalaceIcon, TempleIcon } from '../components/icons/HeritageIcons';
import { isShopEnabled } from './featureFlags';

const shopNavItem = {
  to: '/shop',
  labelKey: 'nav.shop',
  descKey: 'nav.shopDesc',
  Icon: ShoppingBag,
  color: 'text-amber-800',
  activeClass: 'bg-amber-50 text-amber-900',
  matchPrefix: '/shop',
};

/** Explore (शोध) dropdown — icons & colors used in desktop + mobile nav. */
export const exploreNavItems = [
  {
    to: '/forts',
    labelKey: 'nav.forts',
    descKey: 'nav.fortsDesc',
    Icon: FortIcon,
    color: 'text-orange-600',
    activeClass: 'bg-orange-50 text-orange-700',
  },
  {
    to: '/nearby-forts',
    labelKey: 'nav.nearbyForts',
    descKey: 'nav.nearbyFortsDesc',
    Icon: Compass,
    color: 'text-emerald-700',
    activeClass: 'bg-emerald-50 text-emerald-800',
  },
  {
    to: '/temples',
    labelKey: 'nav.temples',
    descKey: 'nav.templesDesc',
    Icon: TempleIcon,
    color: 'text-amber-500',
    activeClass: 'bg-amber-50 text-amber-800',
  },
  {
    to: '/events',
    labelKey: 'nav.events',
    descKey: 'nav.eventsDesc',
    Icon: CalendarDays,
    color: 'text-rose-700',
    activeClass: 'bg-rose-50 text-rose-800',
  },
  ...(isShopEnabled() ? [shopNavItem] : []),
  {
    to: '/blog',
    labelKey: 'nav.blog',
    descKey: 'nav.blogDesc',
    Icon: Newspaper,
    color: 'text-amber-600',
    activeClass: 'bg-amber-50 text-amber-700',
  },
  {
    to: '/wades',
    labelKey: 'nav.wades',
    descKey: 'nav.wadesDesc',
    Icon: PalaceIcon,
    color: 'text-rose-700',
    activeClass: 'bg-rose-50 text-rose-800',
  },
  {
    to: '/history',
    labelKey: 'nav.history',
    descKey: 'nav.historyDesc',
    Icon: ScrollText,
    color: 'text-stone-700',
    activeClass: 'bg-stone-100 text-stone-800',
    matchPrefix: '/history',
  },
  {
    to: '/books',
    labelKey: 'nav.books',
    descKey: 'nav.booksDesc',
    Icon: BookOpen,
    color: 'text-indigo-700',
    activeClass: 'bg-indigo-50 text-indigo-900',
    matchPrefix: '/books',
  },
  {
    to: '/heritage',
    labelKey: 'nav.heritage',
    descKey: 'nav.heritageDesc',
    Icon: Heart,
    color: 'text-rose-700',
    activeClass: 'bg-rose-50 text-rose-800',
    matchPrefix: '/heritage',
  },
  {
    to: '/heritage/gallery',
    labelKey: 'nav.heritageGallery',
    descKey: 'nav.heritageGalleryDesc',
    Icon: Image,
    color: 'text-amber-700',
    activeClass: 'bg-amber-50 text-amber-900',
    matchPrefix: '/heritage/gallery',
  },
];

export const weaponsNavItem = {
  labelKey: 'nav.weapons',
  descKey: 'nav.weaponsDesc',
  Icon: Swords,
  color: 'text-red-600',
  activeClass: 'bg-red-50 text-red-700',
  matchPrefix: '/weapons',
};
